import { apiFetch } from '@/api/apiFetch';
import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { KeyRound, ArrowRight, Loader2, AlertCircle, CheckCircle2 } from 'lucide-react';
import AuthShell, { labelStyle, iconStyle } from '@/components/auth/AuthShell';

export default function Confirm() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await apiFetch('/api/auth/confirm', {
        method: 'POST',
        body: JSON.stringify({ email, code }),
      });
      setDone(true);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.message || 'Código incorrecto o expirado');
    } finally {
      setLoading(false);
    }
  }

  if (done) {
    return (
      <AuthShell>
        <div style={{ textAlign: 'center' }}>
          <CheckCircle2 style={{ width: 48, height: 48, color: 'hsl(var(--success))', margin: '8px auto 16px' }} strokeWidth={1.5} />
          <h2 className="sf-display" style={{ fontSize: 21, fontWeight: 600, color: 'hsl(var(--foreground))', margin: '0 0 8px' }}>
            Cuenta verificada
          </h2>
          <p style={{ fontSize: 14, color: 'hsl(var(--muted-foreground))' }}>Redirigiendo al login...</p>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h2 className="sf-display" style={{ fontSize: 23, fontWeight: 600, color: 'hsl(var(--foreground))', margin: '0 0 4px', letterSpacing: '-0.02em', textAlign: 'center' }}>
        Verifica tu email
      </h2>
      <p style={{ fontSize: 14, color: 'hsl(var(--muted-foreground))', margin: '0 0 28px', textAlign: 'center' }}>
        Hemos enviado un código a <strong style={{ color: 'hsl(var(--foreground))' }}>{email || 'tu correo'}</strong>
      </p>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <label style={labelStyle}>Código de verificación</label>
          <div style={{ position: 'relative' }}>
            <KeyRound style={iconStyle} />
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="123456"
              required
              maxLength={6}
              className="vx-input"
              style={{ width: '100%', height: 44, paddingLeft: 44, paddingRight: 16, borderRadius: 10, border: '1px solid hsl(var(--border))', background: 'hsl(var(--muted) / 0.45)', fontSize: 20, fontWeight: 600, letterSpacing: '0.2em', color: 'hsl(var(--foreground))', boxSizing: 'border-box', outline: 'none', textAlign: 'left', transition: 'border-color 0.2s, box-shadow 0.2s' }}
            />
          </div>
        </div>

        {error && (
          <div style={{ background: 'hsl(var(--destructive) / 0.1)', border: '1px solid hsl(var(--destructive) / 0.3)', borderRadius: 10, padding: '12px 16px', color: 'hsl(var(--destructive))', fontSize: 14, display: 'flex', alignItems: 'center', gap: 8 }}>
            <AlertCircle style={{ width: 16, height: 16, flexShrink: 0 }} />
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="vx-btn-primary"
          style={{ width: '100%', height: 46, borderRadius: 12, border: 'none', color: 'hsl(var(--primary-foreground))', fontSize: 15, fontWeight: 600, cursor: loading ? 'wait' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, opacity: loading ? 0.7 : 1, marginTop: 4 }}
        >
          {loading ? (
            <><Loader2 style={{ width: 18, height: 18, animation: 'spin 1s linear infinite' }} /> Verificando...</>
          ) : (
            <>Verificar cuenta <ArrowRight style={{ width: 16, height: 16 }} /></>
          )}
        </button>

        <p style={{ textAlign: 'center', fontSize: 13, color: 'hsl(var(--muted-foreground))', margin: '4px 0 0' }}>
          <Link to="/login" style={{ color: 'hsl(var(--primary))', fontWeight: 500, textDecoration: 'none' }}>
            Volver al login
          </Link>
        </p>
      </form>
    </AuthShell>
  );
}
